var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { TypographyHeading } from '@honeycomb/ui-core';
import { useHotelSearchResultsTitle } from '../utils';
export function HotelSearchResultsHeading(_a) {
    var { filteredHotelCount, loading = false } = _a, other = __rest(_a, ["filteredHotelCount", "loading"]);
    const title = useHotelSearchResultsTitle(filteredHotelCount, loading);
    return (React.createElement(TypographyHeading, Object.assign({ component: "h1" }, other), title));
}
